'use client';

import { HeadingHero, MetaDefault, Skeleton } from '@terra/ui-design-system';
import { HStack, VStack } from '@terra/ui-styled-system';
import type { ReactNode } from 'react';
import { formatNumber } from '../../utils/formatNumber';

type StripMetricCellProps = {
  label: string;
  icon: ReactNode;
  value: number;
  isLoading: boolean;
  secondary: ReactNode;
};

export function StripMetricCell({
  label,
  icon,
  value,
  isLoading,
  secondary,
}: StripMetricCellProps) {
  return (
    <VStack gap={2} alignItems="flex-start" w="full">
      <HStack gap={1.5} alignItems="center" minW={0}>
        {icon}
        <MetaDefault color="fg.neutral.muted" truncate>
          {label}
        </MetaDefault>
      </HStack>
      {isLoading ? (
        <Skeleton h="32px" w="48px" />
      ) : (
        <HStack gap={2} alignItems="baseline" flexWrap="wrap" minW={0}>
          <HeadingHero
            as="span"
            color={value > 0 ? 'fg.neutral.default' : 'fg.neutral.subtle'}
          >
            {formatNumber(value)}
          </HeadingHero>
          {secondary}
        </HStack>
      )}
    </VStack>
  );
}
